<template>
    <input :type="type"
           class="input"
           :class="{ 'is-dark': darkTheme }"
           :value="value"
           @input="handleInput($event.target.value)"
           @blur="handleBlur"
           :placeholder="placeholder"
           :maxlength="maxlength"
           :max="max"
           :min="min"
           :step="step"
    />
</template>

<script>
export default {
  name: 'TextInput',
  computed: {
    darkTheme() {
      return this.$store.state.system.theme === 'dark';
    },
  },
  methods: {
    handleBlur(event) {
      this.$emit('blur', event);
    },
    handleInput(value) {
      this.$emit('input', value);
    },
  },
  props: {
    maxlength: {
      required: false,
    },
    max: {
      default: null,
      required: false,
      type: Number,
    },
    min: {
      default: null,
      required: false,
      type: Number,
    },
    placeholder: {
      type: String,
      required: false,
    },
    step: {
      default: null,
      required: false,
      type: Number,
    },
    type: {
      default: 'text',
      type: String,
      required: false,
    },
    value: {
      required: true,
    },
  }
}
</script>

<style scoped lang="scss">

</style>
